import { usePathname, useSearchParams } from 'next/navigation';
import { normalizeCommerceLink } from 'utils/links';
import { useEsiteCtx } from 'services/esite/context';
import { SIS_REDIRECT_URL } from 'constants/links';
import { usePathMatch } from 'hooks/use-path-match';
import { getRelativeURLWithParams } from 'utils/url';
import { useEffect, useState } from 'react';
import { useHash } from './use-url-hash';

export const useSisUrl = (isLoggedIn: boolean): string | undefined => {
  const { catalogId, langId } = useEsiteCtx();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const hash = useHash();
  const searchTerm = searchParams.get('q');
  const searchTermString = searchParams.toString();
  const isSearchPage = usePathMatch('/search');

  const [returnPage, setReturnPage] = useState<string>();
  useEffect(() => {
    const currentPage = window.location.href;
    setReturnPage(currentPage);
  }, [pathname, searchTermString, hash]);

  if (isLoggedIn) {
    const sisUrl = normalizeCommerceLink(
      getRelativeURLWithParams(SIS_REDIRECT_URL, {
        langId,
        catalogId,
        returnPage
      })
    );

    if (isSearchPage && searchTerm) {
      return getRelativeURLWithParams(sisUrl, {
        keyword: encodeURIComponent(searchTerm)
      });
    } else {
      return sisUrl;
    }
  }

  return undefined;
};
